package components

import core.enums.EImages
import csstype.AlignItems
import csstype.Display
import csstype.number
import csstype.pct
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import react.useState

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 18.10.22
 * Author : marcusspors
 */

external interface ButtonContentProps : Props {
    var mLeftImage: EImages?
    var mContent: String?
    var mRightImage: EImages?
}

val ButtonContent = FC<ButtonContentProps> { props ->

    val mLeftImage by useState(props.mLeftImage)
    val mContent by useState(props.mContent ?: "")
    val mRightImage by useState(props.mRightImage)

    div {
        css {
            display = Display.flex
            width = 100.pct
            alignItems = AlignItems.center
        }
        mLeftImage?.let {
            ReactHTML.img {
                src = it.mRelativePath
            }
        }
        span {
            css {
                flexGrow = number(1.0)
            }
            +mContent
        }
        mRightImage?.let {
            ReactHTML.img {
                src = it.mRelativePath
            }
        }
    }
}